// src/queries/getMusics.ts
import datoCMSClient from './datoCMSClient';
import { Music } from '../types'; // Import the new 'Music' type

const GET_MUSIC = `
  query {
    allMusicItems {
      title
      artist
      coverImage {
        url
      }
      youtubeUrl
    }
  }
`;

// Function name is 'getMusics', returning Promise<Music[]>
export async function getMusics(): Promise<Music[]> {
  // Assuming your DatoCMS model name's plural API ID is 'allMusicItems'
  const data = await datoCMSClient.request<{ allMusicItems: Music[] }>(GET_MUSIC);
  return data.allMusicItems;
}